import { createContext, useContext, useEffect, useState } from "react";
import { db, logout } from "../firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, getDocs, query, where } from "firebase/firestore";
import { isSupported } from "firebase/messaging";

// Create the context
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const auth = getAuth();

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      setLoading(true);
      if (user) {
        const fireStoreUser = (
          await getDocs(
            query(collection(db, "users"), where("uid", "==", user?.uid)),
          )
        ).docs[0]?.data();
        const isNotificationsSupported = await isSupported();
        setUser({
          ...user,
          role: fireStoreUser?.role ?? "user",
          firebaseToken: fireStoreUser?.firebaseToken ?? "",
          congregation: fireStoreUser?.congregation ?? null,
          isNotificationsSupported,
        });
      } else {
        setUser(null);
      }
      setLoading(false);
    });
  }, [auth]);

  const handleLogout = async () => {
    const res = await logout();
    if (res) {
      setUser(null);
      localStorage.clear();
    }
  };

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        handleLogout,
        loading,
        setSelectedYear,
        selectedYear,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

// Custom hook for easy access
export const useUser = () => useContext(UserContext);
